import { IPage, ISearchPage } from '@/types/AppTypes'
import { httpRequest } from '@/utils/HttpRequest'

//详情
export interface ILedgerDetail {
    id?: string
    prefix?: string
    shopId?: string
    shopCode?: string
    shopName?: string
    branch?: string
    ver?: string
    enable?: string
    orgCode?: string
    orgName?: string
    contact?: string
    phone?: string
    address?: string
    status?: number | boolean
    sourceApp?: string
    categoryName?: string
    typeCode?: string
    typeName?: string
    suffixNum?: number
    settingType?: string
    isYear?: number
    isMonth?: number
    isDate?: number
    style?: string
    note?: string
    ledgerNum?: number
    traceId?: string
    deleteFlag?: number
    createTime?: string
    updateTime?: string
    createUser?: string
    updateUser?: string

    [key: string]: any
}

//搜索条件
export interface ILedgerSearchFields {
    startTime?: string
    endTime?: string

    [key: string]: any
}

export interface ILedgerSearch extends ILedgerSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

class LedgerService {
    async page(searchVo: ILedgerSearch, config: object = {}) {
        const apiUrl = '/threeInspection/scheduling/pb/list'
        return await httpRequest.post<any>(apiUrl, searchVo, config)
    }

    async edit(searchVo: ILedgerSearchFields) {
        const apiUrl = '/threeInspection/scheduling/update'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }

    async one(searchVo: ILedgerSearchFields) {
        const apiUrl = '/threeInspection/scheduling/item/hiddenDanger/list'
        return await httpRequest.post<IPage<ILedgerDetail>>(apiUrl, searchVo)
    }

    //台账修改
    async tzUpdate(searchVo: any) {
        const apiUrl = '/threeInspection/scheduling/tzupdate'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }

    //导出
    async export(searchVo: any) {
        const appPageUrl = `/threeInspection/scheduling/item/export/${searchVo}`
        return await httpRequest.getFile<boolean>(appPageUrl)
    }
}

export const ledgerService = new LedgerService()
